import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../config/api";
import { BASE_API } from "../../../constants/apiUrls";
import { toast } from "../../../lib/toast";
import {
  CommonOthers,
  ErrorMessage,
  GetCommonData,
  GetSingleDataParams,
  Params,
  PostRequest,
} from "../../../types";
import {
  CreateCategoryData,
  GetCategoryData,
  GetCategoryDataParams,
} from "../../../types/category/category";
import { handleApiError } from "../../../utils/errorHandler";

// create
export const createCategoryAsync = createAsyncThunk<
  null,
  PostRequest<CreateCategoryData, CommonOthers>
>(
  "admin/createCategory",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.post(BASE_API.createCategory, data, {
        headers: {},
      });

      reRender(true);
      toast("success", "Category create successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Category create fail");
      return rejectWithValue(error);
    }
  }
);

// get all
export const getAllCategoryAsync = createAsyncThunk<
  GetCommonData<GetCategoryData>,
  Params<GetCategoryDataParams>,
  {
    rejectValue: ErrorMessage;
  }
>("admin-geo/getAllCategory", async ({ params }, { rejectWithValue }) => {
  const { ...rest } = params as GetCategoryDataParams;

  try {
    const data = await AXIOS.get(BASE_API.getAllCategory, {
      params: { ...rest },
      headers: {
        "ngrok-skip-browser-warning": true,
      },
    });

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    handleApiError(error, "Get Category fail");
    return rejectWithValue(error);
  }
});

// update
export const updateCategoryAsync = createAsyncThunk<
  null,
  PostRequest<CreateCategoryData, GetSingleDataParams>
>(
  "admin/updateCategory",
  async ({ data, others: { reRender, id } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateCategory}/${id}`, data, {
        headers: {},
      });

      reRender && reRender(true);
      toast("success", "Category update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      handleApiError(error, "Category update fail");
      return rejectWithValue(error);
    }
  }
);
